import React, {Fragment} from 'react';

import {useSnackbar} from 'notistack';
import {Form, FormikProps} from 'formik';
import {CallMade} from '@material-ui/icons';
import {Box, FormControlLabel, FormGroup, Grid, Typography} from '@material-ui/core';

import {Utils} from 'commons';
import {useSpinner} from 'hooks';
import {DocumentServices} from 'services';
import {InferPropTypes} from 'commons/types/Types';
import {signatureData} from 'commons/defaults/terms-conditions-data';
import {SnackbarVariants, Messages, Constants} from 'commons/constants';
import EfeSignaturePad from 'components/efe-signature-pad/EfeSignaturePad';
import {EfeButtonPrimary, EfeCheckbox, EfeErrorMsg, EfeLink, EfeModal} from 'components';
import {ReactComponent as DownloadIcon} from 'assets/icons/section/action/download.svg';
import {DigitalizedSignatureValues} from 'commons/models/modules/content/DigitalizedSignatureValues';

InnerFormDigitalizedSignature.propTypes = {};

/* eslint-disable react/jsx-handler-names */
function InnerFormDigitalizedSignature(
    props: InferPropTypes<
        typeof InnerFormDigitalizedSignature.propTypes & FormikProps<DigitalizedSignatureValues>
    >
) {
    const {isSubmitting, setFieldValue, values, errors} = props;
    const {enqueueSnackbar} = useSnackbar();
    const [open, setOpen] = React.useState<boolean>(false);
    const [isLoading, setIsLoading] = React.useState<boolean>(false);

    function setSignature(signature: string) {
        setFieldValue('signature', signature);
    }
    function handleOpenClose() {
        setOpen(!open);
    }

    function handleAuthorization() {
        setFieldValue('informationCheck', !values.informationCheck);
    }

    async function onDownload(doc: string) {
        try {
            setIsLoading(true);
            const response = await DocumentServices.getDocument(doc);
            Utils.functions.downloadDocs(response, `${doc}.pdf`);
            enqueueSnackbar(Messages.FILE_DOWNLOAD_OK, {
                variant: SnackbarVariants.SUCCESS,
            });
            setIsLoading(false);
        } catch (error) {
            setIsLoading(false);
            enqueueSnackbar(Messages.FILE_DOWNLOAD_ERROR, {
                variant: SnackbarVariants.ERROR,
            });
        }
    }

    return (
        <Fragment>
            {isLoading && useSpinner(isLoading)}
            <EfeModal
                open={open}
                title={signatureData.title || ''}
                reactElement={
                    signatureData.text?.split('|').map((row) => {
                        return (
                            <Box key={Utils.functions.Generate.uniqueID()} mb={3}>
                                <Typography variant={'body2'}>{row}</Typography>
                            </Box>
                        );
                    }) || <div></div>
                }
                headerActions={[
                    {
                        id: Constants.DOC_TERMS,
                        icon: <DownloadIcon />,
                    },
                ]}
                handleAction={handleOpenClose}
                handleHeaderAction={onDownload}
            />
            <Form noValidate>
                <Box mt={6}>
                    <Typography variant={'body1'}>
                        {'Acepta el '}
                        <EfeLink
                            bold={true}
                            variant='body1'
                            color='primary'
                            underline='always'
                            onClick={() => {
                                onDownload(Constants.DOC_CONTRACT_PREVIEW);
                            }}
                            content={'contrato'}
                        />
                        {' del servicio firmando el siguiente recuadro: '}
                    </Typography>
                    <Grid item xs={12}>
                        <Box mt={4} display='flex' flexDirection='row' justifyContent='center'>
                            <EfeSignaturePad
                                title={''}
                                description={''}
                                signature={values.signature}
                                setSignature={setSignature}
                                readonly={false}
                            />
                        </Box>
                    </Grid>
                    {errors.signature && <EfeErrorMsg message={errors.signature} />}
                    <FormGroup>
                        <FormControlLabel
                            control={
                                <EfeCheckbox
                                    name='informationCheck'
                                    id='informationCheck'
                                    onChange={handleAuthorization}
                                    checked={values.informationCheck}
                                />
                            }
                            label={
                                <Typography variant={'body1'}>
                                    {Messages.START_CHECK_AUTHORIZATION_CONTRACT}
                                    <EfeLink
                                        bold={true}
                                        variant='body1'
                                        color='primary'
                                        underline='always'
                                        onClick={() => {
                                            onDownload(Constants.DOC_CONTRACT_PREVIEW);
                                        }}
                                        content={'contrato'}
                                    />
                                    {Messages.END_CHECK_AUTHORIZATION_CONTRACT}
                                </Typography>
                            }
                        />
                        {errors && errors.informationCheck && (
                            <Box>
                                <EfeErrorMsg message={errors.informationCheck} />
                            </Box>
                        )}
                    </FormGroup>
                </Box>
                <Box m={2}>
                    <Grid container direction='row' justifyContent='flex-end'>
                        <Box pt={6} width={160}>
                            <EfeButtonPrimary
                                fullWidth
                                disabled={isSubmitting}
                                type='submit'
                                endIcon={<CallMade />}>
                                {'Ok'}
                            </EfeButtonPrimary>
                        </Box>
                    </Grid>
                </Box>
            </Form>
        </Fragment>
    );
}

export default InnerFormDigitalizedSignature;
